import { DateTime, Duration, Interval } from 'luxon';
import { TIME_RANGE_MAX, TIME_RANGE_MIN } from '../../constants/TimeRange';

export default (dateFrom: undefined | number, dateTo: undefined | number): boolean => {
  if (dateFrom === undefined || dateTo === undefined) {
    return false;
  }

  const dateFromTime = DateTime.fromMillis(dateFrom);
  const dateToTime = DateTime.fromMillis(dateTo);

  if (!dateFromTime.isValid || !dateToTime.isValid) {
    return false;
  }

  const interval = Interval.fromDateTimes(dateFromTime, dateToTime).length('milliseconds');

  const intervalMin = Interval.fromDateTimes(
    DateTime.local().minus(Duration.fromISO(TIME_RANGE_MIN).toObject()),
    DateTime.local(),
  ).length('milliseconds');

  const intervalMax = Interval.fromDateTimes(
    DateTime.local().minus(Duration.fromISO(TIME_RANGE_MAX).toObject()),
    DateTime.local(),
  ).length('milliseconds');

  return interval >= intervalMin && interval <= intervalMax;
};
